import { css } from 'styled-components';

export default css`
  &&& {
    // background-color: var(--dropdown-menu-background-color);
  }
`;
